<template>
  <div>
    <v-row>
      <v-col>
        <h2>
          Edit Vertical
        </h2>
      </v-col>
    </v-row>
    <Vertical :id="$route.params.id" />
  </div>
</template>

<script>
import Vertical from '../../_components/Vertical';

export default {
  name: 'CreateVertical',
  components: {
    Vertical,
  },
};
</script>
